export class Twitter {
  public tweet (message: string): void {
    window.open(`https://twitter.com/intent/tweet?text=${message}&hashtags=上海蒼龍`, 'twitter')
  }
}
